import { PasswordAuthResult } from "../actions/passwordAuth"

// auth-api の User::PASSWORD_LENGTH（8..128）と同じ。見るのは長さだけで、
// 文字種の組み合わせは求めない（NIST SP 800-63B / auth-api と同じ方針）。
// サインアップと再設定のときだけ見る（ログインでは長さを見ない）。
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 128

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidEmail = (email: string): boolean =>
  EMAIL_PATTERN.test(email.trim())

// 返り値は i18n のキー。問題が無ければ null
export const passwordProblem = (password: string): string | null => {
  if (password.length < PASSWORD_MIN_LENGTH) return "password_too_short"
  if (password.length > PASSWORD_MAX_LENGTH) return "password_too_long"
  return null
}

type Failure = Extract<PasswordAuthResult, { ok: false }>

// ログイン。401 は「パスワード違い・存在しないメール・OAuth だけのアカウント・
// ロック中」をわざと区別しない応答なので、画面でも 1 つの文言にする。
export const signinErrorKey = (result: Failure): string => {
  if (result.status === 401) return "password_login_failed"
  if (result.status === 403) return "email_confirmation_required"
  if (result.status === 429) return "too_many_attempts"
  return "unknown_error"
}

export const signupErrorKey = (result: Failure): string => {
  if (result.status === 422 && result.errors.email) {
    return "account_already_registered"
  }
  if (result.status === 422 && result.errors.password) {
    return "password_rejected"
  }
  if (result.status === 429) return "too_many_attempts"
  return "unknown_error"
}

export const resetErrorKey = (result: Failure): string => {
  if (result.status === 422 && result.errors.reset_password_token) {
    return "password_reset_link_invalid"
  }
  if (result.status === 422 && result.errors.password) {
    return "password_rejected"
  }
  if (result.status === 429) return "too_many_attempts"
  return "unknown_error"
}

export const confirmationErrorKey = (result: Failure): string => {
  if (result.status === 422) return "email_confirmation_link_invalid"
  if (result.status === 429) return "too_many_attempts"
  return "unknown_error"
}

// OAuth（useOauth の onGoogle）と同じ形で、ログイン後の戻り先と nonce を
// code 付きの redirect_uri に足す。/login/callback がこれを読む。
export const buildPostLoginLocation = (
  redirectUriWithCode: string,
  search: string,
): string => {
  const searchParams = new URLSearchParams(search)
  const authedRedirectUri = searchParams.get("redirect_uri") || "/profile"
  const nonce = searchParams.get("nonce")

  let location = `${redirectUriWithCode}&redirect_uri=${authedRedirectUri}`
  if (nonce) {
    location += `&nonce=${nonce}`
  }
  return location
}
